import axios from 'axios';
import {useState} from 'react';
import styles from './LeadExportPage.module.scss';

export function LeadExportPage() {
    const [message, setMessage] = useState('Download every lead in this workspace as a CSV file for Excel or Google Sheets.');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const exportLeads = async () => {
        setLoading(true);
        setMessage('Preparing your CSV file...');
        setIsError(false);
        try {
            const response = await axios.get('/api/extension/leads/export', {responseType: 'blob'});
            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'contacts.csv';
            document.body.append(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
            setMessage('Your contacts.csv download has started.');
        } catch (error: any) {
            setMessage(error.response?.status === 403
                ? 'Export is not available for this workspace.'
                : 'The export could not be completed. Try again.');
            setIsError(true);
        } finally {
            setLoading(false);
        }
    };

    return <main className={styles.host}><section className={styles.content}>
        <h1>Export contacts</h1>
        <p>Download all leads from this workspace in CSV format.</p>
        <button type="button" onClick={exportLeads} disabled={loading}>{loading ? 'Exporting...' : 'Download CSV'}</button>
        <p className={isError ? styles.error : styles.message}>{message}</p>
    </section></main>;
}
